import { render, staticRenderFns } from "./AlreadyOwnedENSContainer.vue?vue&type=template&id=2ebaf0c1&scoped=true&lang=html&"
import script from "./AlreadyOwnedENSContainer.vue?vue&type=script&lang=js&"
export * from "./AlreadyOwnedENSContainer.vue?vue&type=script&lang=js&"
import style0 from "./AlreadyOwnedENSContainer.vue?vue&type=style&index=0&id=2ebaf0c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebaf0c1",
  null
  
)

export default component.exports